import { useState, useEffect } from 'react';
import { DataStore } from 'aws-amplify';
import { TripSheet } from '../models';
import { convertTripSheetToProps, TripSheetProps } from '../datastore/tripSheets';
import { captureError } from '../common/sentry';

export default function useObserveTripsheet(tripsheetId?: string | null) {
  const [tripsheet, setTripsheet] = useState<TripSheetProps>();

  useEffect(() => {
    const normalizedTripsheetId = String(tripsheetId || '').trim();
    if (!normalizedTripsheetId) {
      setTripsheet(undefined);
      return undefined;
    }

    async function fetchInitialTripsheet() {
      try {
        const initialTripsheet = await DataStore.query(TripSheet, normalizedTripsheetId);
        if (!initialTripsheet) return;
        const convertedTripsheet = convertTripSheetToProps(initialTripsheet);
        setTripsheet(convertedTripsheet);
      } catch (error) {
        console.error('Error fetching initial Tripsheet:', error);
        captureError(error, 'useObserveTripsheet-fetchInitial');
      }
    }

    fetchInitialTripsheet();

    const subscription = DataStore.observe(TripSheet, normalizedTripsheetId).subscribe({
      next: (update) => {
        console.log('TripSheet update:', update);
        const convertedTripsheet = convertTripSheetToProps(update.element);
        setTripsheet(convertedTripsheet);
      },
      error: (error) => {
        console.error('Error observing TripSheet:', error);
        captureError(error, 'useObserveTripsheet-observe');
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [tripsheetId]);

  return tripsheet;
}
